module.exports = __webpack_public_path__ + "img/backgroundBuild.a49f2003.png";